import {z} from 'zod'
import {UserRoleE} from '@/types'
import {OptionTypeSchema} from '@/components/commons/select/types/types'

export const enum GUEST_EMAIL_MODEL {
    Email = 'email',
    Password = 'password',
    GenderID = 'gender_id',
    Activities = 'favorite_activities_ids',
    ChatTopics = 'chat_topics_ids',
    WishId = 'wish_id',
    SpokenLanguages = 'spoken_languages_ids',
    Type = 'type',
    Username = 'username',
    PathLocation = 'path_location',
    Description = 'description',
    RemoveAvatar = 'remove_avatar',
    Token = 'auth_token',
    AgeVerifiedAt = 'age_verified_at'
}

export const enum GUEST_EMAIL_MODEL_V3 {
    Email = 'email',
    Password = 'password',
    GenderID = 'genderId',
    Activities = 'favoriteActivities',
    ChatTopics = 'chatTopics',
    WishId = 'wishId',
    SpokenLanguages = 'spokenLanguagesIds',
    Type = 'type',
    Username = 'username',
    PathLocation = 'avatarFileUploadId',
    Description = 'description',
    RemoveAvatar = 'removeAvatar',
    Token = 'authToken',
    AgeVerifiedAt = 'ageVerifiedAt'
}

export const SignupGuestValidationSchema = z.object({
    [GUEST_EMAIL_MODEL.Email]: z.string().min(1, {message: 'validation:required_email'}).email({
        message: 'validation:invalid_email'
    }),
    [GUEST_EMAIL_MODEL.ChatTopics]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL.Activities]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL.SpokenLanguages]: z
        .array(OptionTypeSchema)
        .nonempty({message: 'validation:spoken_languages_required'}),
    [GUEST_EMAIL_MODEL.GenderID]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL.WishId]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL.Token]: z.string().optional()
})

export const SignupGuestValidationV3Schema = z.object({
    [GUEST_EMAIL_MODEL_V3.Email]: z.string().min(1, {message: 'validation:required_email'}).email({
        message: 'validation:invalid_email'
    }),
    [GUEST_EMAIL_MODEL_V3.ChatTopics]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL_V3.Activities]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL_V3.SpokenLanguages]: z
        .array(OptionTypeSchema)
        .nonempty({message: 'validation:spoken_languages_required'}),
    [GUEST_EMAIL_MODEL_V3.GenderID]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL_V3.WishId]: z.array(OptionTypeSchema).optional(),
    [GUEST_EMAIL_MODEL_V3.Token]: z.string().optional()
})

export const SignupGuestPayloadSchemaV3 = z.object({
    [GUEST_EMAIL_MODEL_V3.Type]: z.nativeEnum(UserRoleE),
    [GUEST_EMAIL_MODEL_V3.Email]: z.string(),
    [GUEST_EMAIL_MODEL_V3.GenderID]: z.number().optional(),
    [GUEST_EMAIL_MODEL_V3.ChatTopics]: z.array(z.number()).optional(),
    [GUEST_EMAIL_MODEL_V3.Activities]: z.array(z.number()).optional(),
    [GUEST_EMAIL_MODEL_V3.SpokenLanguages]: z.array(z.number().optional()).optional(),
    [GUEST_EMAIL_MODEL_V3.WishId]: z.number().optional(),
    [GUEST_EMAIL_MODEL_V3.Token]: z.string().optional(),
    language: z.string(),
    firstRookie: z.string().optional(),
    publicGroup: z.number().optional(),
    referralCode: z.string().optional(),
    pathId: z.string().optional(),
    persona: z.string().optional(),
    goalId: z.string().optional(),
    tcId: z.string().optional()
})
